import { Snowflake } from 'lucide-react'

import { useRelativeDate } from '../lib/useRelativeDate'
import { calculateRecipeIngredientQuantities } from '../lib/ingredient'
import type { Ingredient, Plan, Product, Recipe } from './types'

export default function DbCard({
  recipe,
  plan,
  wishlist,
}: {
  recipe?:
    | (Recipe & { ingredients: (Ingredient & { product: Product | null })[] })
    | null
  plan: Plan
  wishlist?: boolean
}) {
  const date = useRelativeDate(plan.plannedAt)
  const ingredientsList = recipe
    ? calculateRecipeIngredientQuantities(
        {
          multiplier: plan.multiplier,
          multiplierFreezer: plan.multiplierFreezer,
        },
        {
          portionsEat: recipe.portionsEat,
          portionsFreezer: recipe.portionsFreezer,
          ingredients: recipe.ingredients,
        }
      )
    : []
  return (
    <div className="">
      {plan.plannedAt ? <div className="opacity-60">{date} &nbsp;</div> : null}
      <h2 className="break-words font-bold text-xl group-hover:underline group-focus-visible:underline opacity-80 group-hover:opacity-100 group-focus-visible:opacity-100 ">
        {plan.display ||
          (recipe
            ? removeURLs(recipe?.display) || 'Untitled recipe'
            : 'Kies een gerecht...')}
        {(plan.portionsFreezer && plan.portionsFreezer < 0) ||
        (plan.multiplierFreezer && plan.multiplierFreezer < 0) ? (
          <Snowflake className="ml-2 inline-block w-5 h-5 -mt-1 text-blue-200" />
        ) : null}
      </h2>
      <div className="flex flex-wrap gap-x-2 gap-y-0 opacity-70 group-hover:opacity-100 group-focus-visible:opacity-100">
        {recipe?.preparationMinutes ? (
          <div className="text-xs font-semibold mr-2">
            ⏱ {recipe.preparationMinutes} min
          </div>
        ) : null}
        {ingredientsList?.map((ing) => (
          <IngredientItem key={ing.id} ingredient={ing} />
        ))}
      </div>
    </div>
  )
}

const IngredientItem = ({
  ingredient,
}: {
  ingredient: Ingredient & { product: Product | null }
}) => {
  return <div className="flex text-xs">{ingredient.product?.display}</div>
}

function removeURLs(text: string | null | undefined) {
  if (!text) return ''
  return text.replace(/https?:\/\/\S+/g, '')
}
